import React from 'react'

const starIcon = ({ rank = 0, value = 0, onClick = () => null }) => {
  return <span onClick={e => onClick(value)}>{value <= rank ? '★' : '☆'}</span>
}

export default starIcon